module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Редактировать тарифный план\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'rate-plan-details',
        params: {
          id: _vm.rate_plan.id
        }
      }
    }
  }, [_vm._v("← Назад к Деталям тарифного плана")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.rate_plan.id) ? _c('a', {
    staticClass: "red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteRatePlan.apply(null, arguments)
      }
    }
  }, [_vm._v("удалить тарифный план")]) : _vm._e()]), _vm._v(" "), _c('rate-plan-edit-form', {
    attrs: {
      "rate-plan": _vm.rate_plan
    },
    on: {
      "after": _vm.handleAfter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-869e1fa8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rate_plan/RatePlanEdit.vue
// module id = 680
// module chunks = 0